// extracted by mini-css-extract-plugin
export default {"dividerBeforeFooter":"GdsnGP","loaderOverlay":"OJGSeT"};